<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.company_defaults')"/>
        <div class="col-12 nopads mt-2">
            <!-- Tabs -->
            <ul class="nav nav-tabs routa-tabs">
                <li class="nav-item routa-tab-nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                        {{ $t('menu.default_inspections') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                        {{  $t('menu.default_task_types')  }}
                    </button>
                     </li>
            </ul>
            <!-- Content -->
            <div class="tab-content routa-tab-content">
                <div class="tab-pane fade" :class="{ show: activeTab === 1, active: activeTab === 1 }">
                    <default-inspections/>
                </div>
                <div class="tab-pane fade" :class="{ show: activeTab === 2, active: activeTab === 2 }">
                    <default-task-types/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/utils/Navbar";
import DefaultInspections from "@/components/contract/DefaultInspections";
import DefaultTaskTypes from "@/components/contract/DefaultTaskTypes";

export default {
    name: 'CompanyDefaults',
    components: {
        Navbar,
        DefaultTaskTypes,
        DefaultInspections,
    },
    data: function () {
        return {
            activeTab: 1,
        }
    }
}
</script>
